import { render, staticRenderFns } from "./settingTemplateLetterPage.vue?vue&type=template&id=3f5971f2&scoped=true&"
import script from "./settingTemplateLetterPage.vue?vue&type=script&lang=js&"
export * from "./settingTemplateLetterPage.vue?vue&type=script&lang=js&"
import style0 from "./settingTemplateLetterPage.vue?vue&type=style&index=0&id=3f5971f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5971f2",
  null
  
)

export default component.exports